(() => {
  function handleSaveButtons() {
    const saveButtons = [...document.querySelectorAll('status-save-button')]
    if (saveButtons.length) {
       // ------------TD CHANGE-----------
      const saveButtonStyling = `
        * {
          text-transform: uppercase;
        }
        .save-button {
          position: relative;
          z-index: 1;
          color: #1b1b1b !important;
        }        
      `
        // --------- END TD CHANGE--------
      const saveButtonStyle = new CSSStyleSheet
      saveButtonStyle.replaceSync(saveButtonStyling)
      saveButtons.forEach((button) => {
        if(button.shadowRoot) {
           button.shadowRoot.adoptedStyleSheets.push(saveButtonStyle)
        }
       
        document.addEventListener('status:item:save', ({detail}) => {
          if (detail.productId == button.productId && button.getAttribute('selected-label')) {
            button.innerText = button.getAttribute('selected-label')
          }
        })
        document.addEventListener('status:item:remove', ({detail}) => {
          if (detail.productId == button.productId && button.getAttribute('deselected-label')) {
            button.innerText = button.getAttribute('deselected-label')
          }
        })
      }) 
    }
  }
  // ------------TD CHANGE-----------
  function handleWishlistTriggers() {
    const wishlistTriggers = [...document.querySelectorAll('status-saved-link')]
    if (wishlistTriggers.length) {
      const wishlistTriggersStyling = `
        .indicator {
          font-size: .625rem;
          font-weight: 600;
          width: 17px;
          height: 17px;
          display: flex;
          justify-content: center;
          align-items: center;
          top: 0;
          right: -9px;
        }
      `
      const wishlistTriggersStyling2 = `
        .indicator {
          opacity:0;
        }
      `
      const wishlistTriggersStyle = new CSSStyleSheet
      const wishlistTriggersStyle2 = new CSSStyleSheet
      wishlistTriggersStyle.replaceSync(wishlistTriggersStyling)
      wishlistTriggersStyle2.replaceSync(wishlistTriggersStyling2)
      wishlistTriggers.forEach((trigger) => {
        const ind = trigger.shadowRoot.querySelector('.indicator') != null && trigger.shadowRoot.querySelector('.indicator').innerHTML 
        if(ind) {

          if(ind !== '0') {
            trigger.shadowRoot.adoptedStyleSheets.push(wishlistTriggersStyle)
          } else {
            trigger.shadowRoot.adoptedStyleSheets.push(wishlistTriggersStyle2)
          }
        }
        
        
      })
    }
  }
  // --------- END TD CHANGE--------
  document.addEventListener("status:loaded", () => {
    handleSaveButtons();
    handleWishlistTriggers();
  })
  document.addEventListener('quick-view:open', handleSaveButtons)
})()

// --------- Accordion --------

if (!customElements.get("accordion-wrapper")) {
  class Accordion extends HTMLElement {
    constructor() {
      super();
      this.options = this.dataset.options;
      this.items = this.querySelectorAll(".td-accordion__item");
      this.onlyOneActive = false;
      window.addEventListener("load", () => {
        this.bindEvents();
      });
      if(this.items) {
        this.items.forEach((elem) => {
          if(elem.classList.contains('is-active')) {
           const content = elem.querySelector(".td-accordion__content")
           if(content) content.style.maxHeight = content.scrollHeight + "px";
          }
        })
      }
    }

    bindEvents() {
      const el = this;
      this.items.forEach(function (item) {
        const toggle = item.querySelector(".td-accordion__toggle");
        if (toggle) {
          toggle.addEventListener("click", function (event) {
            event.preventDefault();
            el.toggle(item.dataset.item);
          });
          if (item.dataset.open) {
            el.toggle(item.dataset.item);
          }
        }

        const toggleNext = item.querySelector(".td-accordion__toggle-next");
        if (toggleNext) {
          toggleNext.addEventListener("click", function (event) {
            event.preventDefault(), el.toggle(parseInt(item.dataset.item) + 1);
          });
        }
      });
    }

    toggle(currentItem) {
      const el = this;
      this.items.forEach(function (item) {
        const content = item.querySelector(".td-accordion__content");
        if (!content) return;
        if (item.dataset.item == currentItem) {
          if (item.classList.contains("is-active")) {
            content.style.maxHeight = null;
          } else {
            content.style.maxHeight = content.scrollHeight + "px";
          }
          item.classList.toggle("is-active");
        } else if (el.onlyOneActive) {
          item.classList.remove("is-active");
          content.style.maxHeight = null;
        }
      });
    }
  }

  customElements.define("accordion-wrapper", Accordion);
}

document.addEventListener("DOMContentLoaded", function () {
  window.upcartOnCartLoaded = function (cart) {
    if (!cart || cart.item_count > 0) return;
    const cartFooter = document.querySelector(".upcart-footer");
    if(cartFooter) {
      const loopOnstore = document.createElement('loop-onstore');
      cartFooter.appendChild(loopOnstore);
    }
    const customEmptyCart = document.querySelector("[data-empty-cart]");
    const customEmptyCartWrapper = document.querySelector(
      '#upCart div[class^="styles_CartPreview__empty"]'
    );
    if (!customEmptyCart || !customEmptyCartWrapper) return;
    customEmptyCartWrapper.innerHTML = customEmptyCart.innerHTML;
  };
});

// Sauce basket upsell gallery
window.addEventListener('aftersell-upcart:public-events:cart-loaded', function () {
  const upsellContainer = document.querySelector('.sauce-basket-upsell-container');
  if (!upsellContainer) return;

  // Remove all existing children
  while (upsellContainer.firstChild) {
    upsellContainer.removeChild(upsellContainer.firstChild);
  }

  // Create and insert the widget script
  const script = document.createElement('script');
  script.src = 'https://app.addsauce.com/widgets/basket_upsell/38018b6d-265d-81a3-05b6-27ff27c56dce/_basket_upsell_gallery.js';
  script.className = 'snapppt-widget';
  upsellContainer.appendChild(script);
});
